import qs from 'qs';
import { network } from 'services/network';

export const setAcrossVersionHashCodeConfig = ({
    projectId,
    isSetActivityId,
    isSetActivityType,
    isSetFullPathParentNames,
    isSetName,
    isSetParentName,
    isSetUuid,
    isSetWbsLevel,
}) => {
    const querystring = qs.stringify(
        {
            projectId,
            isSetActivityId,
            isSetActivityType,
            isSetFullPathParentNames,
            isSetName,
            isSetParentName,
            isSetUuid,
            isSetWbsLevel,
        },
        { addQueryPrefix: true, skipNulls: true },
    );
    const url = `api/bo/setAcrossVersionHashCodeConfig${querystring}`;
    return network.post(url).then((response) => response.data);
};
